import { FlatAspect } from "@/models/HomePageSearchResponse";

// AJB: will need to use these in the UI
// AJB: "-stallions" suffix could be avoided by levarging the selected vertical?
const STALLION_BREED_OPTIONS: FlatAspect[] = [
  { id: "242", label: "Thoroughbred", slug: "thoroughbred-stallions" },
  { id: "243", label: "Andalusian", slug: "andalusian-stallions" },
  { id: "244", label: "Appaloosa", slug: "appaloosa-stallions" },
  { id: "245", label: "Arabian", slug: "arabian-stallions" },
  { id: "247", label: "Brumby / Heritage horse", slug: "brumby-heritage-horse-stallions" },
  { id: "248", label: "Clydesdale", slug: "clydesdale-stallions" },
  { id: "249", label: "Coloured", slug: "coloured-stallions" },
  { id: "250", label: "Cross Bred", slug: "cross-bred-stallions" },
  { id: "251", label: "Donkey / Mule", slug: "donkey-mule-stallions" },
  { id: "252", label: "Draught horse", slug: "draught-horse-stallions" },
  { id: "253", label: "Friesian", slug: "friesian-stallions" },
  { id: "254", label: "Gypsy horse", slug: "gypsy-horse-stallions" },
  { id: "255", label: "Haflinger", slug: "haflinger-stallions" },
  { id: "256", label: "Hanoverian", slug: "hanoverian-stallions" },
  { id: "257", label: "Miniature", slug: "miniature-stallions" },
  { id: "258", label: "Non registered horses", slug: "non-registered-horses-stallions" },
  { id: "259", label: "Other", slug: "other-stallions" },
  { id: "260", label: "Paint", slug: "paint-stallions" },
  { id: "261", label: "Palomino", slug: "palomino-stallions" },
  { id: "262", label: "Palouse", slug: "palouse-stallions" },
  { id: "263", label: "Pinto", slug: "pinto-stallions" },
  { id: "265", label: "Pony", slug: "pony-stallions" },
  { id: "266", label: "Quarter horse", slug: "quarter-horse-stallions" },
  { id: "267", label: "Riding Pony", slug: "riding-pony-stallions" },
  { id: "268", label: "Shetland", slug: "shetland-stallions" },
  { id: "269", label: "Shire Horse", slug: "shire-horse-stallions" },
  { id: "271", label: "Standardbred", slug: "standardbred-stallions" },
  { id: "273", label: "Warmblood", slug: "warmblood-stallions" },
  { id: "274", label: "Welsh", slug: "welsh-stallions" },
  { id: "376", label: "Sportaloosa", slug: "sportaloosa-stallions" },
  { id: "378", label: "Sport Horse", slug: "sport-horse-stallions" },
  { id: "380", label: "Knabstrupper", slug: "knabstrupper-stallions" },
  { id: "382", label: "Australian Stock Horse", slug: "australian-stock-horse-stallions" },
  { id: "383", label: "Arabian Derivatives", slug: "arabian-derivatives-stallions" },
  { id: "385", label: "Irish Draught/Sport Horse", slug: "irish-draught-sport-horse-stallions" },
  { id: "397", label: "Connemara", slug: "connemara-stallions" },
  { id: "399", label: "Caspian", slug: "caspian-stallions" },
  { id: "400", label: "Waler", slug: "waler-stallions" },
  { id: "403", label: "Polo / Polocrosse", slug: "polo-polocrosse-stallions" },
  { id: "404", label: "Morgan", slug: "morgan-stallions" },
  { id: "406", label: "Cleveland Bay", slug: "cleveland-bay-stallions" },
  { id: "408", label: "Spanish Mustangs", slug: "spanish-mustangs-stallions" },
  { id: "421", label: "Lusitano", slug: "lusitano-stallions" },
];

export default STALLION_BREED_OPTIONS;
